export default __webpack_public_path__ + "static/media/3132 spice rack C side.03abcbe0.png";